import { Button, InputNumber, List, Space, Typography, Popconfirm } from 'antd';
import { PlusOutlined, DeleteOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import useGisStore from '../../stores/gisStore';

const { Text } = Typography;

export default function HeatmapPanel() {
  const { heatmaps, removeHeatmap, toggleHeatmap, drawing, startDrawing, cancelDrawing, addHeatmap } = useGisStore();
  const isDrawing = drawing.mode === 'heatmap';

  const handleStartDraw = () => {
    startDrawing('heatmap', {
      heatmapName: `热力图 ${heatmaps.length + 1}`,
      heatmapRadius: 20,
    });
  };

  const handleFinishManual = () => {
    if (drawing.points.length === 0) return;
    addHeatmap({
      name: drawing.heatmapName || `热力图 ${heatmaps.length + 1}`,
      points: drawing.points.map((p) => ({ ...p, value: Math.random() })),
      visible: true,
      radius: drawing.heatmapRadius,
      maxOpacity: 0.8,
      gradient: { 0.0: 'blue', 0.25: 'cyan', 0.5: 'lime', 0.75: 'yellow', 1.0: 'red' },
    });
    cancelDrawing();
  };

  return (
    <div style={{ padding: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <Text strong style={{ fontSize: 13 }}>热力图</Text>
        {!isDrawing ? (
          <Button type="primary" size="small" icon={<PlusOutlined />} onClick={handleStartDraw}>
            添加
          </Button>
        ) : (
          <Space size={4}>
            <Button size="small" type="primary" onClick={handleFinishManual} disabled={drawing.points.length === 0}>
              完成 ({drawing.points.length}点)
            </Button>
            <Button size="small" onClick={cancelDrawing}>取消</Button>
          </Space>
        )}
      </div>

      {isDrawing && (
        <div style={{ marginBottom: 12, padding: 8, background: '#1a1a2e', borderRadius: 4, border: '1px solid #30475e' }}>
          <Text style={{ fontSize: 11, color: '#52c41a', display: 'block', marginBottom: 4 }}>
            🖱 左键点击地图添加数据点 ({drawing.points.length}个)
          </Text>
          <Text style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 4 }}>
            右键点击完成添加
          </Text>
          <Text style={{ fontSize: 11, color: '#888' }}>
            按 ESC 取消
          </Text>
          {drawing.points.length > 0 && (
            <div style={{ marginTop: 8 }}>
              <Text style={{ fontSize: 10, color: '#666', display: 'block' }}>已选点位:</Text>
              {drawing.points.map((pt, i) => (
                <Text key={i} style={{ fontSize: 10, color: '#999', display: 'block' }}>
                  {i + 1}. {pt.lon.toFixed(4)}, {pt.lat.toFixed(4)}
                </Text>
              ))}
            </div>
          )}
        </div>
      )}

      <List
        dataSource={heatmaps}
        locale={{ emptyText: '暂无热力图' }}
        renderItem={(hm) => (
          <List.Item style={{ padding: '8px 0' }}>
            <Space style={{ width: '100%', justifyContent: 'space-between' }}>
              <Space>
                <Button
                  type="text"
                  size="small"
                  icon={hm.visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                  onClick={() => toggleHeatmap(hm.id)}
                  style={{ color: hm.visible ? '#1890ff' : '#666' }}
                />
                <Text style={{ fontSize: 12 }}>{hm.name}</Text>
                <Text style={{ fontSize: 10, color: '#666' }}>{hm.points.length}点</Text>
              </Space>
              <Popconfirm title="删除热力图？" onConfirm={() => removeHeatmap(hm.id)}>
                <Button type="text" size="small" danger icon={<DeleteOutlined />} />
              </Popconfirm>
            </Space>
          </List.Item>
        )}
      />
    </div>
  );
}
